export const LOCAL_STORAGE_CART = "yolo-cart"
